module.exports = __webpack_public_path__ + "img/artist_form.5bbf75b.webp";